var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { css } from '@emotion/react';
import { darkThemeStyle } from '../theme';
import { tokens } from '../tokens';
// Mapping between heading size, HTML elements, and actual font size
var sizeMap = {
    large: {
        element: 'h3',
        fontSize: tokens.fontSizes.large,
    },
    medium: {
        element: 'h4',
        fontSize: tokens.fontSizes.medium,
    },
    xlarge: {
        element: 'h2',
        fontSize: tokens.fontSizes.xlarge,
    },
    xxlarge: {
        element: 'h1',
        fontSize: tokens.fontSizes.xxlarge,
    },
};
var headingStaticStyle = css({
    fontWeight: tokens.fontWeights.bold,
    lineHeight: tokens.lineHeights.default,
    marginBottom: tokens.spacing.small,
});
export function headingStyle(_a) {
    var inverted = _a.inverted, size = _a.size;
    return __spreadArray(__spreadArray([], __read((inverted ? [darkThemeStyle] : [])), false), [
        headingStaticStyle,
        css({
            fontSize: sizeMap[size].fontSize,
        }),
    ], false);
}
export function sizeToElement(_a) {
    var size = _a.size;
    return sizeMap[size].element;
}
